import { render, staticRenderFns } from "./LoaderSolid.vue?vue&type=template&id=fcae09e8&"
import script from "./LoaderSolid.vue?vue&type=script&lang=js&"
export * from "./LoaderSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports